import Vue from 'vue'
import { Table, Empty, Collapse, Col, Row, Form, List, Icon, Divider, Button, Message, Input, InputNumber, Alert, Spin, FormModel, Card, Layout } from 'ant-design-vue'

Vue.use(Button)
Vue.use(Input)
Vue.use(Form)
Vue.use(Collapse)
Vue.use(List)
Vue.use(Spin)
Vue.use(Empty)
Vue.use(Alert)
Vue.use(Col)
Vue.use(Row)
Vue.use(Table)
Vue.use(FormModel)
Vue.use(Card)
Vue.use(InputNumber)
Vue.use(Layout)
Vue.use(Divider)
Vue.use(Icon)

Vue.prototype.$message = Message
